import { AccessDenied as e } from "../../errors/access-denied.mjs";
import { BadRequest as t, BadRequestWithViolations as n } from "../../errors/bad-request.mjs";
import { ConflictError as r } from "../../errors/conflict-error.mjs";
import { FailedDependency as i } from "../../errors/failed-dependency.mjs";
import { InternalError as a } from "../../errors/internal-error.mjs";
import { invalidTokenErrorMessages as o } from "../../errors/invalid-token-error.mjs";
import { LockedError as s } from "../../errors/locked-error.mjs";
import { MaintenanceError as c } from "../../errors/maintenance-error.mjs";
import { NetworkError as l } from "../../errors/network-error.mjs";
import { NotFound as u } from "../../errors/not-found.mjs";
import { PayloadTooLarge as d } from "../../errors/payload-too-large.mjs";
import { TooManyRequests as f } from "../../errors/too-many-requests.mjs";
import { UnauthorizedResponse as p } from "../../errors/unauthorized-response.mjs";
import { UnprocessableContentError as m } from "../../errors/unprocessable-content-error.mjs";
import { AxiosError as h, isCancel as g } from "axios";
//#region src/fetch/http-base-client/get-error-mapper.ts
var _ = (_) => {
	let v = !1, y = [], b = () => _.post("/api/user/token/regenerate"), x = (e) => {
		y.push(e);
	}, S = () => {
		y.forEach((e) => e()), y = [];
	}, C = async (e) => {
		let t = e.config;
		if (!v) {
			v = !0;
			try {
				return await b(), v = !1, S(), await _(t);
			} catch (e) {
				throw v = !1, y = [], e;
			}
		}
		return new Promise((e) => {
			x(() => {
				e(_(t));
			});
		});
	};
	return async (_) => {
		if (g(_)) throw _;
		if (_ = _, _.code === h.ERR_NETWORK) throw new l();
		let v = _.response;
		if (!v) throw _;
		switch (v.status) {
			case 400: throw "errors" in v.data ? new t(v.data) : new n(v.data);
			case 401:
				if (o.includes(v.data.message)) return await C(_);
				{
					let e = v.data.redirect || v.data.location;
					if (e) throw new p(e);
				}
				break;
			case 403: {
				let t = v.data?.redirect || v.data?.location;
				throw new e(t);
			}
			case 404: throw new u(u.isNotFoundResponse(v.data) ? v.data : void 0);
			case 409: throw new r(v.data);
			case 413: throw new d();
			case 422: throw new m(v.data);
			case 423: throw new s();
			case 424: throw new i(v.data.title);
			case 429:
				if (v.data?.errors) throw new f(v.data);
				break;
			case 503: throw new c();
			case 500:
			case 502: throw new a();
		}
		throw _;
	};
};
//#endregion
export { _ as getErrorMapper };
